// GA4GH DUO consent vocabularies (base permission + scope modifiers).
// Source: git show origin/seller:src/App.js lines 172..202.
// Scores + adjustments here are display-only — the server is the source of
// truth via server/internal/pricing/pricing.go duoPermissionScores / duoModifierAdjustments.

export const duoPermissions = [
  { value: 'NRES', label: 'No Restriction (DUO:0000004)', score: 100, tip: 'Your consent allows use for any purpose, including commercial' },
  { value: 'GRU', label: 'General Research Use (DUO:0000042)', score: 75, tip: 'Your consent allows any research purpose but may not explicitly cover commercial use' },
  { value: 'HMB', label: 'Health/Medical/Biomedical (DUO:0000006)', score: 60, tip: 'Your consent limits use to health-related research only' },
  { value: 'DS', label: 'Disease-Specific Research (DUO:0000007)', score: 40, tip: 'Your consent limits use to a specific disease or condition' },
  { value: 'POA', label: 'Population Origins/Ancestry (DUO:0000011)', score: 30, tip: 'Your consent limits use to ancestry/population research only' },
];

export const duoModifiers = [
  { value: 'NCU', label: 'Non-commercial use only', adjustment: -30, tip: 'Eliminates pharma and commercial AI buyers' },
  { value: 'PS', label: 'Project-specific restriction', adjustment: -25, tip: 'Locks data to a single named project' },
  { value: 'IS', label: 'Institution-specific restriction', adjustment: -20, tip: 'Only one institution can use the data' },
  { value: 'US', label: 'User-specific restriction', adjustment: -15, tip: 'Only approved individuals can access' },
  { value: 'GS', label: 'Geographical restriction', adjustment: -15, tip: 'Limits use to a specific region/country' },
  { value: 'TS', label: 'Time limit on use', adjustment: -10, tip: 'Data must be deleted after a period' },
  { value: 'NMDS', label: 'No methods/AI research', adjustment: -10, tip: 'Excludes AI/ML algorithm development' },
  { value: 'GSO', label: 'Genetic studies only', adjustment: -10, tip: 'Excludes phenotype-only research' },
  { value: 'RS', label: 'Research-specific restriction', adjustment: -5, tip: 'Minor scope limitation' },
  { value: 'NPOA', label: 'Ancestry research prohibited', adjustment: -5, tip: 'Excludes one use case' },
];

export const duoAdminModifiers = [
  { value: 'IRB', label: 'Ethics approval required', adjustment: 0 },
  { value: 'PUB', label: 'Publication required', adjustment: 0 },
  { value: 'COL', label: 'Collaboration required', adjustment: 0 },
  { value: 'MOR', label: 'Publication moratorium', adjustment: 0 },
  { value: 'RTN', label: 'Return to database/biobank', adjustment: 0 },
  { value: 'CC', label: 'Clinical care use', adjustment: 0 },
];
